import Footer from "../../layout/Footer/Footer";
import Navigation from "../../layout/Navigation/Navigation";

const Features = () => {
  return (
    <div>
      <Navigation page="Feature" />
      <div className="pt-0 md:pt-20">Features</div>
      <Footer />
    </div>
  );
};

export default Features;
